import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import objectPath from "object-path";
export var newApiError = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(request, response) {
    var responseData, displayMessage, apiError;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return response.json();
        case 3:
          responseData = _context.sent;
          _context.next = 8;
          break;
        case 6:
          _context.prev = 6;
          _context.t0 = _context["catch"](0);
        case 8:
          displayMessage = objectPath.get(responseData, "msg");
          apiError = new Error("Request to \"".concat(request.method, " ").concat(request.path, "\" failed with status ").concat(response.status));
          apiError.type = "API";
          apiError.status = response.status;
          apiError.displayMessage = displayMessage;
          apiError.responseData = responseData || {};
          apiError.request = request;
          apiError.response = response;
          return _context.abrupt("return", apiError);
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 6]]);
  }));
  return function newApiError(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var newLoginInvalidError = function newLoginInvalidError(parentError) {
  var _parentError$response;
  var loginInvalidError = new Error();
  loginInvalidError.type = "LOGIN_INVALID";
  loginInvalidError.displayMessage = parentError.displayMessage;
  loginInvalidError.captchaSiteKey = parentError === null || parentError === void 0 || (_parentError$response = parentError.responseData) === null || _parentError$response === void 0 ? void 0 : _parentError$response.captchaSiteKey;
  return loginInvalidError;
};
export var newCaptchaRequiredError = function newCaptchaRequiredError(parentError) {
  var _parentError$response2, _parentError$response3;
  var captchaRequiredError = new Error();
  captchaRequiredError.type = "CAPTCHA_REQUIRED";
  captchaRequiredError.displayMessage = parentError.displayMessage ? parentError.displayMessage : parentError === null || parentError === void 0 || (_parentError$response2 = parentError.responseData) === null || _parentError$response2 === void 0 ? void 0 : _parentError$response2.msg;
  captchaRequiredError.captchaSiteKey = parentError === null || parentError === void 0 || (_parentError$response3 = parentError.responseData) === null || _parentError$response3 === void 0 ? void 0 : _parentError$response3.captchaSiteKey;
  captchaRequiredError.path = parentError.path;
  return captchaRequiredError;
};
export var newNotUniqueGuestAccount = function newNotUniqueGuestAccount(parentError) {
  var _parentError$response4;
  var notUniqueGuestAccountError = new Error();
  notUniqueGuestAccountError.type = "GUEST_ACCOUNT_NOT_UNIQUE";
  notUniqueGuestAccountError.displayMessage = parentError.displayMessage ? parentError.displayMessage : parentError === null || parentError === void 0 || (_parentError$response4 = parentError.responseData) === null || _parentError$response4 === void 0 ? void 0 : _parentError$response4.msg;
  return notUniqueGuestAccountError;
};
export var newValidationFailedError = function newValidationFailedError(parentError) {
  var validationFailedError = new Error();
  validationFailedError.type = "VALIDATION_FAILED";
  validationFailedError.displayMessage = parentError.displayMessage;
  validationFailedError.errors = objectPath.get(parentError, ["responseData", "data"], {});
  return validationFailedError;
};
export var newResetPasswordTokenInvalidError = function newResetPasswordTokenInvalidError(parentError) {
  var resetPasswordTokenInvalidError = new Error();
  resetPasswordTokenInvalidError.type = "RESET_PASSWORD_TOKEN_INVALID";
  resetPasswordTokenInvalidError.title = parentError.title;
  resetPasswordTokenInvalidError.displayMessage = parentError.displayMessage;
  return resetPasswordTokenInvalidError;
};